import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const RestrictedWords = Loadable(
    lazy(() =>
        import("./restrictedWords").then(({ RestrictedWords }) => ({
            default: RestrictedWords,
        }))
    )
);

export const RestrictedWordsRoutes = [
    {
        path: "/restricted-words",
        exact: true,
        element: (
            <AuthorizedRoute
               
                moduleIds={[]}
                allowFullAccess={true}
            >
                <RestrictedWords />
            </AuthorizedRoute>
        ),
    },
];
